<template>
  <div v-if="loading"  class="mt-220 d-flex justify-content-center align-items-center">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="mt-80 pt-5 serv" v-else>
    <three-dots class="dots"/>
    <h1 class="title">Стоимость услуг</h1>
    <div class="services">
      <div class="services-content">
        <div class="services-content-block d-flex justify-content-between">
          <div class="services-content-block_content">
            <span class="color_bold_black">Индивидуальная консультация по скайпу</span>
          </div>
          <div class="services-content-block_content">
            <span class="color_blue"><span class="numbers" style="font-weight: 600">{{price1}}</span> евро / <span class="numbers" style="font-weight: 600">{{time1}}</span> минут</span>
            <span class="color_blue"><span class="numbers" style="font-weight: 600">{{price2}}</span> евро / <span class="numbers" style="font-weight: 600">{{time2}}</span> минут</span>
          </div>
        </div>
        <div class="services-content-block d-flex justify-content-between">
          <div class="services-content-block_content">
            <span class="color_bold_black">Индивидуальная консультация по переписке</span>
            <span class="content_text">Ваш запрос с описанием ситуации и мой комплексный ответ с формированием рекомендаций</span>
          </div>
          <div class="services-content-block_content">
            <span class="color_blue mr_100"><span class="numbers" style="font-weight: 600">{{price3}}</span> евро</span>
          </div>
        </div>
        <div class="services-content-block d-flex justify-content-between">
          <div class="services-content-block_content">
            <span class="color_bold_black">Переписка в течение <span class="numbers" style="font-weight: 600">3</span> дней</span>
            <span class="content_text">Я задаю уточняющие вопросы, помогаю вам глубже разобраться с ситуацией, при вашем желании даю самостоятельное задание, вы можете писать столько, сколько хотите, а я отвечаю два раза в день, по окончании мы вместе формулируем варианты и шаги к изменениям</span>
          </div>
          <div class="services-content-block_content">
            <span class="color_blue mr_100"><span class="numbers" style="font-weight: 600">{{price4}}</span> евро</span>
          </div>
        </div>
      </div>
      <div class="services-text mt-5">
        <p>Оплата всегда происходит перед началом консультации (цена с перерасчетом по нац. банку на момент оплаты). Я свяжусь с вами в течении дня после заполнения заявки.</p>
        <p>Стоимость периодически повышается, поэтому успейте закрепить за вами неизменную цену - когда мы вступаем в сотрудничество, дальнейший рост цены консультаций вас не касается.</p>
        <p>О возможности переноса консультации прошу  сообщить мне письменно за сутки до начала сеанса</p>
      </div>
    </div>
    <go-record class="mt-60"/>
    <videos/>
    <Footer/>
  </div>
</template>

<script>
  import Footer from '@/views/Home/components/Footer';
  import Videos from '@/views/Home/components/Videos';
  import GoRecord from '@/views/Home/components/GoRecord';
  import ThreeDots from '@/components/icons/ThreeDots';
  import { mapActions, mapState } from 'vuex';
  export default {
    name: "Services",
    metaInfo: {
      title: 'Услуги'
    },
    components: { GoRecord, Footer, Videos, ThreeDots},
    data() {
      return {
        loading: true,
        price1: null,
        time1: null,
        price2: null,
        time2: null,
        price3: null,
        price4: null,
      }
    },
    async mounted() {
      await this.loadDetails()
    },
    computed: {
      ...mapState('price', ['skype', 'consultation', 'threeDays'])
    },
    methods: {
      ...mapActions('price', [
        'fetchSkypeConsultation', 'fetchChatConsultation', 'fetchThreeDaysConsultation',
        'skypeConsultation', 'chatConsultation', 'threeDaysConsultation']),
      async loadDetails() {
        this.loading = true
        await this.fetchSkypeConsultation()
        this.price1 = this.skype.price1
        this.time1 = this.skype.time1
        this.price2 = this.skype.price2
        this.time2 = this.skype.time2
        await this.fetchChatConsultation()
        this.price3 = this.consultation.price
        await this.fetchThreeDaysConsultation()
        this.price4 = this.threeDays.price
        this.loading = false
      },
    }
  }
</script>

<style lang="scss">
  .mt-40 {
    margin-top: 60px;
  }
  .services {
    display: block;
    max-width: 1000px;
    padding-left: 24px;
    padding-right: 24px;
    margin-left: auto;
    margin-right: auto;
    font-family: 'Raleway', sans-serif;
    &-content {
      &-block {
        &:nth-child(1) {
          border-top:  1px solid #cad4e5;;
        }
        padding-top: 32px;
        padding-bottom: 32px;
        border-bottom:  1px solid #cad4e5;;
        &_content {
          &:nth-child(1) {
            width: 70%;
          }
          &:nth-child(2) {
            width: 30%;
          }
          .color_bold_black {
            font-size: 17px;
            font-weight: 600;
            line-height: 1.71;
            display: block;
            color: #1f1f1f;
          }
          .content_text {
            display: block;
            margin-top: 16px;
            font-size: 17px;
            line-height: 1.71;
            color: #7e7e7e;
          }
          .color_blue {
            display: block;
            font-size: 17px;
            font-weight: 600;
            line-height: 1.71;
            color: #5ec8f5;
            text-align: right;
            &:nth-child(2) {
              margin-top: 8px;
            }
          }
          .mr_100 {
            margin-right: 95px;
          }
        }
      }
    }
    &-text {
      p {
        font-size: 17px;
        line-height: 1.99;
        margin-top: 0;
        color: #1f1f1f;
        text-align: justify;
        margin-bottom: 24px;
      }
    }
  }
  @media screen and (max-width: 650px){
    .serv {
      .title {
        margin-bottom: 53px;
      }
    }
    .services {
      &-content {
        &-block {
          flex-wrap: wrap;
          &_content {
            width: 100% !important;
            .color_bold_black {
              text-align: center;
              margin-bottom: 24px;
              font-size: 20px;
            }
            .content_text {
              display: block;
              margin-top: 16px;
              text-align: center;
              margin-bottom: 24px;
            }
            .color_blue {
              display: block;
              font-size: 24px;
              font-weight: 600;
              line-height: 1.71;
              color: #5ec8f5;
              text-align: center;
              &:nth-child(2) {
                margin-top: 8px;
              }
            }
            .mr_100 {
              margin-right: 0px;
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>